import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

const ActionGroupElement = ({
  className,
  handleOnClick,
  label,
  title,
  action
}) => {
  const actionMap = {
    add: (
      <div className="mr-10 fx center">
        <SVGIcon name="Add" color="#1908f7" />
      </div>
    ),
    remove: (
      <div className="fx center">
        <SVGIcon name="RuleMinus" size="sm" color='#FA3F3F'/>
      </div>
    )
  };
  return (
    <Button
      className={`${className} flex center`}
      title={title}
      onClick={(e) => handleOnClick(e)}
    >
      {actionMap[action]}
      <Label>{label}</Label>
    </Button>
  );
};

const Label = styled.div`
  color: #1908f7;
  font-size: 14px;
`;

const Button = styled.button`
  background: none !important;
  border: none !important;
  cursor: pointer;
  :focus {
    outline: none;
  }
`;

ActionGroupElement.displayName = 'ActionGroupElement';

ActionGroupElement.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  title: PropTypes.string,
  action: PropTypes.string
};

export default ActionGroupElement;
